/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_Tab_ConsumeInputs */

const en_admin_credits_tab_consume = /** @type {(inputs: Admin_Credits_Tab_ConsumeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consume`)
};

/**
* | output |
* | --- |
* | "Consume" |
*
* @param {Admin_Credits_Tab_ConsumeInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_credits_tab_consume = /** @type {((inputs?: Admin_Credits_Tab_ConsumeInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_Tab_ConsumeInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_credits_tab_consume(inputs)
});
export { admin_credits_tab_consume as "admin.credits.tab_consume" }